require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-grosspetersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-grosspetersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-grosspetersdorf!./.cache/json/betreuungseinrichtungen-oberwart-grosspetersdorf.json
// module id = 1005
// module chunks = 231608221292675